module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-01.438c53fc.jpg";